module.exports = __webpack_public_path__ + "img/ai_audio_text_background.991a27d.png";